import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-vluchtelingen',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconVluchtelingen {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M36 6.61c0 .66-.69 1.1-1.29.82L23 1.8 11.29 7.44A.907.907 0 0 1 10 6.62c0-.35.21-.68.53-.82L22.16.18c.53-.25 1.14-.25 1.68 0l11.63 5.61c.32.15.53.47.53.82M17.5 15c1.93 0 3.5-1.57 3.5-3.5S19.43 8 17.5 8 14 9.57 14 11.5s1.57 3.5 3.5 3.5m11 0c1.93 0 3.5-1.57 3.5-3.5S30.43 8 28.5 8 25 9.57 25 11.5s1.57 3.5 3.5 3.5M34 32h-2v3c0 .55-.45 1-1 1h-2.99v-5.93c0-1.14-.93-2.06-2.07-2.06h-6.93v-.47a3.53 3.53 0 0 0-3.53-3.53h-1.47v-.54c0-1.68-1.39-3.15-3-3.46 0-.02 0-3 3-3h18c1.66 0 3 1.34 3 3v11c0 .55-.45 1-1 1Zm-7.99-9c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3M17 27.53v6.97c0 .83-.67 1.5-1.5 1.5h-14C.67 36 0 35.33 0 34.5v-7.01c0-.83.67-1.5 1.5-1.5H5v-2.51c0-.83.69-1.49 1.54-1.49h3.95c.84 0 1.51.65 1.51 1.46v2.54h3.47c.84 0 1.53.69 1.53 1.53ZM10 24H7v2h3z"/>
</svg>

    );
  }
}
